export const brand = {
  name: "瓜田黑料",
  suffix: "舆论反转观察站",
  slogan: "反转不是终点，看清才是",
  intro:
    "瓜田黑料不做爆料的第一现场，只做信息的第二现场：把散落各处的说法收敛成一条正序时间线，把双方回应并排放在一起，再标清楚哪些已被证实、哪些仍是单方说法。",
  email: "contact@guatianheiliao.cn",
  clueEmail: "clue@guatianheiliao.cn",
  copyright: "瓜田黑料 · 舆论反转观察站",
  established: "2021 年起持续更新",
};

export const navLinks = [
  { label: "首页", to: "/", type: "page" },
  { label: "案例库", to: "/cases", type: "page" },
  { label: "观察指南", to: "/guide", type: "page" },
  { label: "关于我们", to: "/about", type: "page" },
];

export const anchorLinks = [
  { label: "风向速览", hash: "wind", desc: "此刻正在转向的事" },
  { label: "重点反转", hash: "focus", desc: "本周最典型的一次逆转" },
  { label: "案例精选", hash: "picks", desc: "按分类翻看档案" },
  { label: "判定方法", hash: "method", desc: "四步核验法" },
  { label: "常见问题", hash: "faq", desc: "读者最常问的几件事" },
  { label: "线索投递", hash: "submit", desc: "把你看到的说给我们" },
];

export const tickerItems = [
  { label: "某音乐节阵容调整事件", trend: "反转", heat: 92, note: "主办方公布补偿方案后舆论回落" },
  { label: "短剧剧本比对争议", trend: "升温", heat: 78, note: "第三方比对报告公开，讨论转向判定标准" },
  { label: "餐厅后厨视频风波", trend: "回落", heat: 41, note: "完整时间线视频释出后热度下降" },
  { label: "直播价格话术争议", trend: "升温", heat: 66, note: "平台公布比价口径说明" },
  { label: "公益募捐公示质疑", trend: "反转", heat: 58, note: "口径差异被解释，质疑方撤下原帖" },
  { label: "校园短视频拼接事件", trend: "回落", heat: 33, note: "原始素材公开，二次剪辑被证实" },
  { label: "职场爆料匿名帖", trend: "待定", heat: 47, note: "缺少可核实材料，暂列观察中" },
  { label: "代言解约传闻", trend: "待定", heat: 52, note: "双方均未正面回应，信息不完整" },
];

export const homeStats = [
  { value: "1,284", label: "已归档事件" },
  { value: "2,970", label: "收录双方回应" },
  { value: "68%", label: "事件出现明显反转" },
  { value: "36 小时", label: "平均反转出现时间" },
];

export const methodSteps = [
  {
    no: "01",
    title: "先还原时间，再判断对错",
    desc: "把每条信息按发布时间排好，标出谁先说的、谁后回应的。顺序本身就是最重要的证据之一，很多争议只要排好时间线就会自己消解。",
  },
  {
    no: "02",
    title: "区分「说法」与「材料」",
    desc: "当事人的表述属于说法，合同、聊天记录原件、监控、后台数据、盖章文件属于材料。说法需要材料支撑，材料需要核实来源。",
  },
  {
    no: "03",
    title: "检查传播链上的每一次改写",
    desc: "同一条消息经过截图、搬运、加字幕、二次剪辑后，语义可能完全不同。回到最早的发布者，看看中间被拿掉了什么。",
  },
  {
    no: "04",
    title: "给结论留出更新口",
    desc: "把当前结论标注为「基于现有信息」。新证据出现时，允许结论被改写，而不是为了维护立场去挑拣事实。",
  },
];

export const evidenceLevels = [
  {
    level: "A 级",
    name: "可核验材料",
    desc: "原始文件、完整视频、平台后台数据、第三方机构比对报告等可被独立复查的材料。",
    tone: "primary",
  },
  {
    level: "B 级",
    name: "具名当事人陈述",
    desc: "愿意承担表达责任、身份可确认的当事人公开说明，但仍属于单方说法，需要交叉验证。",
    tone: "secondary",
  },
  {
    level: "C 级",
    name: "匿名爆料与转述",
    desc: "无署名截图、群聊转发、「朋友的朋友说」。可作为线索方向，不能作为结论依据。",
    tone: "accent",
  },
];

export const misleadingTechniques = [
  { name: "时间错位", desc: "把不同日期发生的事并列展示，制造因果关系。" },
  { name: "截断语境", desc: "只保留一句最有冲击力的话，删掉前后铺垫。" },
  { name: "身份替代", desc: "用「业内人士」「知情者」替代具体身份，让转述显得可信。" },
  { name: "情绪加字幕", desc: "在原始画面上加夸张字幕与音效，改变观众的第一印象。" },
  { name: "单侧举证", desc: "只呈现一方材料，另一方的回应被折叠进评论区。" },
];

export const faqs = [
  {
    q: "什么是舆论反转？",
    a: "指事件在传播过程中，由于新证据、新回应或更完整的原始材料出现，公众的主流判断发生方向性改变。反转不等于真相大白，它只是说明此前流行的版本存在缺陷。",
  },
  {
    q: "怎么判断一条黑料是真是假？",
    a: "先看有没有可核验材料，再看材料来自谁、有没有被剪辑过，最后看被指方的回应是否有实质性内容。三个环节里缺任何一个，都只能算「待核实」，不能当结论用。",
  },
  {
    q: "看到单方面爆料，普通读者应该怎么做？",
    a: "不做二次传播的加速器。可以记录、可以观察，但不必急着站队。等被指方回应、等原始材料出现，再决定要不要形成判断，成本很低，收益很高。",
  },
  {
    q: "「澄清」和「洗白」有什么区别？",
    a: "澄清是用材料回应具体指控，允许被反驳；洗白是用情绪和话术绕开指控本身，回避关键问题。判断方法很简单：看回应有没有正面回答最关键的那个问题。",
  },
  {
    q: "一场风波的热度一般会持续多久？",
    a: "从我们归档的一千多起事件看，热度峰值通常出现在首轮爆料后的 6 至 18 小时，多数话题在 72 小时内回落，而真正出现反转的时间点，平均在首次爆料后 36 小时左右。",
  },
  {
    q: "你们会收录哪些类型的事件？",
    a: "只要满足两个条件：存在公开可查的信息链，且出现了明显的舆论方向变化。纯粹的情绪争执、没有可核实材料的传闻，以及涉及具体个人隐私的内容，都不在收录范围。",
  },
];

export const readingTips = [
  "结论标注为「基于现有信息」，新证据出现时会同步更新。",
  "涉及具体个人的事件一律匿名化，不呈现可定位的信息。",
  "任何未经核实指控，都不在本站作二次传播。",
  "发现站内信息有误，可通过邮箱申请补充说明。",
];

export const principles = [
  { title: "只梳理，不裁决", desc: "我们整理信息与时间线，不对当事人作出事实认定，也不代替司法与监管判断。" },
  { title: "标注证据等级", desc: "每一条关键信息都标明来源类型与可信等级，让读者知道结论建立在什么之上。" },
  { title: "双方表述对等呈现", desc: "回应汇总要求双方在同一版面出现，篇幅与位置尽量对等，不做倾斜式编排。" },
  { title: "去标识与隐私保护", desc: "案例以匿名化方式呈现，不公开与事件无关的个人信息、联系方式与家庭细节。" },
];

export const selfCheckList = [
  "我知道这条信息最早是谁发布的吗？",
  "我看到的画面是完整版本还是二剪片段？",
  "发布者有没有提供可被独立核验的材料？",
  "被指方是否已经作出回应？",
  "如果今天出现反向材料，我愿意修正自己的判断吗？",
];

export const glossary = [
  { term: "正序时间线", desc: "按信息实际发布的时间先后重新排列的版本，用于对抗“最新消息在上”造成的错觉。" },
  { term: "证据等级", desc: "把材料按可核验程度分为 A / B / C 三级，让结论的可靠性可以被看见。" },
  { term: "语境截断", desc: "保留最具冲击力的一小段表述，删去前后铺垫，使原意发生偏移。" },
  { term: "单侧举证", desc: "只呈现一方材料，另一方的回应被折叠或忽略，造成判断失衡。" },
  { term: "反转", desc: "新证据或完整材料出现后，主流判断发生方向性改变，不等同于真相大白。" },
];

export const testimonials = [
  { name: "林一舟", role: "内容运营", text: "以前刷到热搜就跟着情绪走，现在习惯先来这里看时间线。顺序一摆出来，很多东西就看懂了。" },
  { name: "周慕晨", role: "高校教师", text: "把它当成媒介素养的案例库在用，学生很容易理解什么叫证据等级和语境截断。" },
  { name: "郑禾", role: "品牌公关", text: "回应汇总那一栏对我帮助最大。同一个争议，双方各自强调了什么、回避了什么，一目了然。" },
  { name: "苏晚青", role: "自由撰稿人", text: "风向变化那部分做得克制，没有煽动感。写稿前查一遍，能少踩很多坑。" },
];

export const timelineSpotlight = [
  { time: "09-07 21:40", title: "首轮爆料出现", detail: "某账号发布一段 18 秒片段，指控主办方在已知变动的情况下继续售票。", kind: "claim" },
  { time: "09-08 00:15", title: "话题登上热榜", detail: "片段被大量搬运并加字幕传播，情绪迅速集中到「欺诈」二字。", kind: "spread" },
  { time: "09-08 11:02", title: "主办方首次回应", detail: "公布调整通知的发出时间截图，称变动发生在售票截止之后，但未回应补偿问题。", kind: "response" },
  { time: "09-09 16:30", title: "出现关键新材料", detail: "场馆方公开档期沟通邮件，显示阵容变动在更早的时间点已被讨论。", kind: "turn" },
  { time: "09-10 10:00", title: "补偿方案落地", detail: "主办方公布退票与交通补贴方案，多数讨论转向执行细节与到账时间。", kind: "clarify" },
];